import React from 'react';
import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

export const VEHICLE_ACCESS_RIGHTS_RESOURCE = 'vehicleAccessRights';

export default ComposedComponent =>
  reduxFetch(() => [
    {
      resource: VEHICLE_ACCESS_RIGHTS_RESOURCE,
      method: 'get',
      request: vehicleId => ({
        url: apiRoutes.vehicleAccessRights(vehicleId),
      }),
    },
  ])(props => <ComposedComponent {...props} />);
